var map = {
	"./0.gif": 20,
	"./farquaad_screenshot.png": 283,
	"./level_screenshot.png": 298,
	"./pigandkey.png": 883,
	"./shrekcover.jpg": 417,
	"./shrekdead.jpg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 682;